import { PromptDataDtoToEntity } from "src/app/features/ApplicationProfile/subFeatures/PromptData/services/mappers/PromptDataDtoToEntity";
import type { PromptDataDto } from "src/app/features/ApplicationProfile/subFeatures/PromptData/types/PromptDataDto";
import type { PromptDataEntity } from "src/app/features/ApplicationProfile/subFeatures/PromptData/types/PromptDataEntity";
import type { ResourcePageDto } from "../../../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../../../core/types/fe/entities/ResourcePageEntity";

export const PromptDataTableDtoMapper = (input: Readonly<ResourcePageDto<PromptDataDto>>): ResourcePageEntity<PromptDataEntity> => {
    return {
        list: input.list ? input.list.map(PromptDataDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
